import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './layout/header-panel/header/header.component';
import { AuthService } from './services/auth/auth.service';
import { RbacService } from './services/rbac/rbac.service';
import { UnsavedChangesBrowserBackService } from './services/unsaved-changes/unsaved-changes-browser-back.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ CommonModule, RouterOutlet, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'montage';

  private readonly authService = inject(AuthService);
  private readonly rbacService = inject(RbacService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly unsavedBrowserBack = inject(UnsavedChangesBrowserBackService);

  ngOnInit(): void {
    // Keep browser Back on the custom Unsaved Changes dialog (not native leave).
    this.unsavedBrowserBack.start();

    if (this.authService.isAuthenticated()) {
      this.authService.hydrateUserProfileFromToken();
      this.rbacService
        .ensureContextLoaded()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.enforceRouteAccess();
        });
      this.rbacService.contextChanges$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.enforceRouteAccess();
        });
    }
  }

  showAuthenticatedShell(): boolean {
    if (!this.authService.isAuthenticated()) {
      return false;
    }
    const path = this.router.url.split('?')[0];
    return path !== '/login' && path !== '/login2';
  }

  private enforceRouteAccess(): void {
    if (!this.rbacService.isContextReady()) {
      return;
    }
    const path = this.router.url.split('?')[0];
    if (path === '/login' || path === '/login2') {
      return;
    }
    if (!this.rbacService.canAccessRoute(this.router.url)) {
      const target = this.rbacService.getDefaultRoute();
      if (target !== path) {
        this.router.navigate([target], { replaceUrl: true });
      }
    }
  }
}
